module.exports = __webpack_public_path__ + "img/vertical_4_7_9016.603ce754.png";